import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var DeleteFromItemList = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation DeleteFromItemList($type: ItemListType!, $navigationId: String!) {\n    deleteFromItemList(type: $type, navigationId: $navigationId) {\n      message\n      status\n    }\n  }\n"])));
export default DeleteFromItemList;